import React from 'react';
import { useNavigate } from 'react-router-dom';
import { navCategories } from '../mockData';

/**
 * Composant Navigation - Barre de navigation horizontale sur 2 lignes
 * Utilisé à la fois sur la page d'accueil et les autres pages
 * Utilise les couleurs de marque dynamiquement
 */
const Navigation = ({ onCategoryClick }) => {
  const navigate = useNavigate();

  // Fonction pour gérer la navigation des catégories
  const handleCategoryClick = (categoryName) => {
    // Si un callback est fourni (page d'accueil), l'utiliser
    if (onCategoryClick) {
      onCategoryClick(categoryName);
      return;
    }

    // Sinon, utiliser la navigation standard
    const routes = {
      "Toile De Store": "/",
      "Toile de Store Droit": "/store-droit",
      "Toile de Store à Double Pente": "/store-double-pente",
      "Lambrequin Seul": "/lambrequin",
      "Toile De Pergola": "/pergola",
      "Brise-Vue De Balcon": "/brise-vue",
      "Toile de Store au Metre": "/toile-au-metre"
    };
    
    const route = routes[categoryName];
    if (route) {
      navigate(route);
    }
  };

  return (
    <nav className="bg-brand text-white">
      <div className="max-w-7xl mx-auto px-4 py-2">
        {/* Première ligne - 5 catégories */}
        <ul className="flex items-center justify-center gap-2 mb-1">
          {navCategories.slice(0, 5).map((category, index) => (
            <li key={index}>
              <button 
                onClick={() => handleCategoryClick(category.name)}
                className="px-4 py-2 hover:bg-brand-dark transition-colors flex items-center gap-1 text-sm rounded"
              >
                {category.name}
              </button>
            </li>
          ))}
        </ul>
        
        {/* Deuxième ligne - 4 catégories + boutons */}
        <ul className="flex items-center justify-center gap-2">
          {navCategories.slice(5, 9).map((category, index) => (
            <li key={index + 5}>
              <button 
                onClick={() => handleCategoryClick(category.name)}
                className="px-4 py-2 hover:bg-brand-dark transition-colors flex items-center gap-1 text-sm rounded"
              >
                {category.name}
              </button>
            </li>
          ))}
          
          {/* Bouton Marquage/Flocage */}
          <li>
            <button 
              onClick={() => navigate('/devis-marquage-flocage')}
              className="px-4 py-2 hover:bg-brand-dark transition-colors text-sm rounded"
            >
              Marquage/Flocage
            </button>
          </li>
          
          {/* Bouton Marquage Lumineux/Flocage */}
          <li>
            <button 
              onClick={() => navigate('/devis-marquage-lumineux-flocage')}
              className="px-4 py-2 hover:bg-brand-dark transition-colors text-sm rounded"
            >
              Marquage Lumineux/Flocage
            </button>
          </li>
          
          {/* Bouton DEVIS */}
          <li>
            <button 
              onClick={() => navigate('/demande-devis')}
              className="px-4 py-2 hover:bg-brand-dark transition-colors text-sm rounded bg-brand-dark"
            >
              DEVIS
            </button>
          </li>
          
          {/* Bouton PRO */}
          <li>
            <button 
              onClick={() => navigate('/pro/login')}
              className="px-4 py-2 hover:bg-brand-dark transition-colors text-sm rounded bg-brand-dark"
            >
              PRO
            </button>
          </li>
          
          {/* Bouton BLOG */}
          <li>
            <button 
              onClick={() => navigate('/blog')}
              className="px-4 py-2 hover:bg-brand-dark transition-colors text-sm rounded bg-brand-dark"
            >
              BLOG
            </button>
          </li>
          
          {/* Bouton SERVICE POSE */}
          <li>
            <button 
              onClick={() => navigate('/service-pose')}
              className="px-4 py-2 hover:bg-brand-dark transition-colors text-sm rounded bg-brand-dark"
            >
              SERVICE POSE
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
